<template>
    <transition name="fade">
        <div class="VideoGallery" v-show="videoGalleryVisible" @click="toggleVideoGallery()">
            <video class="vg-video" autoplay controls :src="url" @click="$event.stopPropagation()"></video>
        </div>  
    </transition>
</template>

<style scoped>
    .VideoGallery{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        background: #000000d0;
    }
    .vg-container{
        position: absolute;
        margin-top: 30px;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
    }
    .vg-video{
        margin-top: 40px;
        width: 90%;
        max-height: 85%;
        border-radius: 0px 0px 10px 10px;
    }
</style>
    
<script>
import {mapGetters,mapMutations} from 'vuex';


export default {
    data: function () {
        return {
            videoGalleryVisible: false,
            url: null,
        }
    }, 
    computed: {
        ...mapGetters(['logoURL','localUserID','moderatorMode']),
    },
	methods: {
        ...mapMutations(["setDialogueOpen","setStopModeratorModeSignals"]),
        toggleVideoGallery(){
            this.videoGalleryVisible = !this.videoGalleryVisible;
            if(!this.videoGalleryVisible){
                document.getElementsByClassName("vg-video")[0].pause();
                // TODO: send event to videolist with currenttime
            }
        },
        initDialogue(e){
            this.url = e.detail.url;
            document.getElementsByClassName("vg-video")[0].currentTime = e.detail.time;
            this.toggleVideoGallery();
        },
    },
    mounted: function(){
        window.addEventListener('openVideoGallery',this.initDialogue);
    }
}

</script>